export const filteredOptions = [
    {name: 'country', level: 0, filteredOtions: 'filteredOptionsCountry'},
    {name: 'city', level: 0, filteredOtions: 'filteredOptionsCity'},
    {name: 'cityAddress', level: 0, filteredOtions: 'filteredOptionsCityAddress'},
    {name: 'state', level: 1, filteredOtions: 'filteredOptionsState'},
    {name: 'stateAddress', level: 1, filteredOtions: 'filteredOptionsStateAddress'},
    {name: 'municipality', level: 2, parent: 1, filteredOtions: 'filteredOptionsMunicipality'},
    {name: 'parish', level: 3, parent: 2, filteredOtions: 'filteredOptionsParish'},
    {name: 'employment', filteredOtions: 'filteredOptionsEmployment'},
    {name: 'destinationCountry', filteredOtions: 'filteredOptionsDestinationCountry'},
    {name: 'otherCountry', level: 0, filteredOtions: 'filteredOptionsOtherCountry'},
    {name: 'veCountry', filteredOtions: 'filteredOptionsOtherVeCountry'},
    {name: 'otherCity', level: 0, filteredOtions: 'filteredOptionsOtherCity'},
    {name: 'otherState', level: 1, filteredOtions: 'filteredOptionsOtherState'},
    {name: 'nationality', level: 1, filteredOtions: 'filteredOptionsNationality'},
];

export const validation_msgs = {
    'autocompleteControlCountry': [
      { type: 'invalidAutocomplete', message: 'No se encontró el país. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'País requerido' }
    ],
    'autocompleteControlCity': [
      { type: 'invalidAutocomplete', message: 'No se encontró la ciudad. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'Ciudad requerida' }
    ],
    'autocompleteControlState': [
      { type: 'invalidAutocomplete', message: 'No se encontró el estado. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'Estado requerido' }
    ],
    'autocompleteControlEmployment': [
      { type: 'invalidAutocomplete', message: 'No se encontró la ocupación. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'Ocupación requerido' }
    ],
    'autocompleteControlDestinationCountry': [
      { type: 'invalidAutocomplete', message: 'No se encontró el país. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'País destino requerido' }
    ],
    'autocompleteControlMissions': [
      { type: 'invalidAutocomplete', message: 'No se encontró la misión. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'Misión requerido' }
    ],
    'autocompleteControlProcedures': [
      { type: 'invalidAutocomplete', message: 'No se encontró el trámite. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'Trámite requerido' }
    ],
    'autocompleteControlEmployments': [
      { type: 'invalidAutocomplete', message: 'No se encontró la ocupación. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'Ocupación requerido' }
    ],
     'autocompleteControlMunicipality': [
      { type: 'invalidAutocomplete', message: 'No se encontró el municipio. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'Municipio requerido' }
    ],
    'autocompleteControlParish': [
      { type: 'invalidAutocomplete', message: 'No se encontró la parroquia. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'Parroquia requerida' }
    ],
    'autocompleteControlNationality': [
      { type: 'invalidAutocomplete', message: 'No se encontró la nacionalidad. Debe seleccionar una opción valida.' },
      { type: 'required', message: 'Este campo es requerido' }
    ],
};

export enum PROCEDURE_TYPES {
  ECS = 'E-CS',
  ECRC = 'EC-RC',
  ECRN = 'EC-RN',
  ECREEP = 'EC-REEP',
  EFV = 'E-FV',
  ECTPB = 'EC-TPB',
  ADJ = 'A-DJ',
  AV = 'AV',
  INCVRE = 'IN-CVRE',
  CFARC = 'C-FARC',
  VI = 'VI',
  PIORP = 'PI-ORP',
  EORP = 'E-ORP',
  IPDCV = ' I-PDCV',
  APMIL = 'AP-MIL',
  EDV = 'E-DV',
  RR = 'RR',
  T = 'T',
  TRE = 'TR-E',
  TRRI = 'TR-RI',
  TRRE = 'TR-RE',
  TRED = 'TR-ED',
  TRL = 'TR-L',
  TRF = 'TR-F',
  TRN = 'TR-N',
  TRFI = 'TR-F-I',
  TREI = 'TR-E-I',
  CVDEM = 'CVDEM',
  CVPBP = 'CVPBP',
  CVPBPEP = 'CVPBPEP',
  CPBEC = 'CPBEC',
  CPPBEC = 'CPPBEC',
  CVEC = 'CVEC',
  ECAP = 'EC-AP',
  ECVPB = 'EC-VPB',
  ECVPBEX = 'EC-VPB EX',
  SCAPGAS = 'SCAP-GAS',
  CNO = 'CNO',
  CDA = 'CDA',
  CDAT = 'CDAT',
  CDCA = 'CDCA',
  CDE = 'CDE',
  CIDP = 'CIDP',
  CDLC = 'CDLC',
  CDLV = 'CDLV',
  CDOR = 'CDOR',
  CDPU = 'CDPU',
  CSA = 'CSA',
  CSV = 'CSV',
  CF = 'CF',
  CLE = 'CLE',
  CLR = 'CLR',
  CU = 'CU',
  CDPI = 'CDPI',
  CFRN = 'C-FRN',
  CRN = 'C-RN',
  CUV = 'C-UV',
  CUEP = 'C-UEP',
  NJ = 'NJ',
  LFPDE = 'LF-PDE',
  LFPME = 'LF-PME',
  LFPNE = 'LF-PNE',
  RN = 'RN',
  CNMC = 'CNMC',
  CDO = 'CDO',
  ARRM = 'AR-RM',
  CFEM = 'CF-EM',
  CFED = 'C-FED',
}

export enum CODITIONS_CODE {
  TRANSIT = 'ET',
  PERMANENT = 'PE',
}

export enum PROCEDURE_CODES {
  CODE_0001 = '0001', //registro militar
  CODE_0002 = '0002', //registro electoral
  CODE_0003 = '0003', //registro nacimiento
  CODE_0004 = '0004', //registro reconocimiento
  CODE_0005 = '0005', //registro matrimonio
  CODE_0006 = '0006', //registro defuncion
  CODE_0007 = '0007', //certificacion reconocimiento consular
  CODE_0008 = '0008', //certificacion extracto matrimonio
  CODE_0009 = '0009', //certificacion extracto defuncion
  CODE_0010 = '0010', //certificacion nacimiento consular
  CODE_0011 = '0011', //certificacion fe vida
  CODE_0012 = '0012', //constancia tramitacion pasaporte
  CODE_0013 = '0013', //constancia registro consular
  CODE_0014 = '0014', //constancia tramitacion renuncia nacionalidad
  CODE_0015 = '0015', //constancia renuncia nacionalidad
  CODE_0016 = '0016', //documento viaje
  CODE_0017 = '0017', //autorizacion viaje niños, niñas adolecentes
  CODE_0018 = '0018', //emision carta solteria
  CODE_0019 = '0019', //otorgamiento renovacion poder especial general
  CODE_0020 = '0020', //verificacion identidad
  CODE_0021 = '0021', //visa turista
  CODE_0022 = '0022', //visa transeunte negocios
  CODE_0023 = '0023', //visa transeunte laboral
  CODE_0024 = '0024', //visa transeunte religioso
  CODE_0025 = '0025', //visa transeunte estudiante
  CODE_0026 = '0026', //visa transeunte familiar venezolano
  CODE_0027 = '0027', //visa transeunte reingreso
  CODE_0028 = '0028', //visa transeunte empresario/industrial
  CODE_0029 = '0029', //visa transeunte empleado domestico
  CODE_0030 = '0030', //visa familiar transeunte inversionista
  CODE_0031 = '0031', //certificado analisis
  CODE_0032 = '0032', //certificado antiguedad
  CODE_0033 = '0033', //certificado calidad
  CODE_0034 = '0034', //certificado envejecimiento
  CODE_0035 = '0035', //certificado inscripcion producto
  CODE_0036 = '0036', //certificado libre contaminacion
  CODE_0037 = '0037', //certificado libre venta
  CODE_0038 = '0038', //certificado origen
  CODE_0039 = '0039', //certificado patente invencion
  CODE_0040 = '0040', //certificado pureza
  CODE_0041 = '0041', //certificado sanidad animal
  CODE_0042 = '0042', //certificado sanidad vegetal
  CODE_0043 = '0043', //certificado uso enseres
  CODE_0044 = '0044', //certificado uso vehiculos
  CODE_0045 = '0045', //certificado libre estroncio
  CODE_0046 = '0046', //certificado libre radioactividad
  CODE_0047 = '0047', //certificado consumo humano
  CODE_0048 = '0048', //carta origen
  CODE_0049 = '0049', //constancia no objecion
  CODE_0050 = '0050', //constancia pasaporte china
  CODE_0051 = '0051', //constancia prorroga pasaporte china
  CODE_0052 = '0052', //constancia visa emitida china
  CODE_0053 = '0053', //constancia verificacion documentos efectos mortuorios chile
  CODE_0054 = '0054', //constancia vigencia pasaporte chile
  CODE_0055 = '0055', //constancia nacionalidad mujer casada
  CODE_0056 = '0056', //constancia antecedentes policiales guatemala
  CODE_0057 = '0057', //constancia antecedentes policiales arabia saudita
  CODE_0059 = '0059', //certificacion de fe de vida
  CODE_0063 = '0063', //extracto de reconocimiento
  CODE_0079 = '0079', //visa turista para hijos
}